// cart-upsell
document.addEventListener('DOMContentLoaded', function() {
  loadUpsellProducts();
  setupUpsellListeners();
});

// Define category-to-upsell collection mappings
const categoryUpsellMap = {
  'n64': 'upsell-n64-cart',
  'gameboy': 'upsell-gameboy',
  'playstation': 'upsell-playstation',
  'snes': 'upsell-snes-cart',
  'wii': 'upsell-wii-cart',
  'ps-vita': 'upsell-ps-vita-cart',
  'ps2': 'upsell-ps2-cart',
  'psp': 'upsell-psp-cart',
  'ps3': 'upsell-ps3-cart',
  'gamecube': 'upsell-gamecube-cart',
  'ds-lite': 'upsell-ds-lite-cart',
  '3ds': 'upsell-3ds-cart'
};

// Store all collection products in cache
const collectionCache = new Map();

// Track recently added products (temporary state)
const recentlyAddedProducts = new Set();

// Carousel state
let currentSlide = 0;
let slidesPerView = 2;
let totalSlides = 0;

// Guard flag to prevent multiple simultaneous loads
let isUpsellLoading = false;

function setupUpsellListeners() {
  // Listen for shipping progress updates
  document.addEventListener('shippingProgressUpdated', function() {
    setTimeout(() => {
      loadUpsellProducts();
    }, 300);
  });
  
  // Listen for cart updates
  document.addEventListener('ajaxCart.afterCartLoad', () => {
    setTimeout(() => {
      loadUpsellProducts();
    }, 500);
  });
  
  document.addEventListener('cart.requestComplete', () => {
    setTimeout(() => {
      loadUpsellProducts();
    }, 500);
  });
  
  // Listen for cart drawer events
  document.addEventListener('cart:updated', (event) => {
    setTimeout(() => {
      // Only reload if event doesn't come from upsell
      if (!event.detail || !event.detail.fromUpsell) {
        loadUpsellProducts();
      }
    }, 500);
  });
  
  document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
      loadUpsellProducts();
    }, 500);
  });
  
  // Sync recently added products when cart is fully reloaded
  document.addEventListener('cart:build', (event) => {
    if (event.detail && event.detail.cart && event.detail.cart.items) {
      syncRecentlyAddedWithCart(event.detail.cart.items);
    }
  });
  
  // Sync when cart is updated
  document.addEventListener('cart:updated', (event) => {
    if (event.detail && event.detail.cart && event.detail.cart.items) {
      syncRecentlyAddedWithCart(event.detail.cart.items);
    }
  });
  
  // Override fetch for cart updates (for non-upsell cart additions)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && url.includes('/cart/add.js')) {
      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          // After adding product via other means, reload upsells
          setTimeout(() => {
            loadUpsellProducts();
          }, 800);
        }
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };
}

// Sync recently added products with current cart state
function syncRecentlyAddedWithCart(cartItems) {
  const cartProductIds = new Set(cartItems.map(item => item.product_id));
  
  // Create a new Set with only products that are currently in cart
  const newRecentlyAdded = new Set();
  
  recentlyAddedProducts.forEach(productId => {
    if (cartProductIds.has(productId)) {
      newRecentlyAdded.add(productId);
    }
  });
  
  // Update the Set
  recentlyAddedProducts.clear();
  newRecentlyAdded.forEach(id => recentlyAddedProducts.add(id));
  
  console.log('Synced recently added products with cart. Current:', Array.from(recentlyAddedProducts));
}

async function loadUpsellProducts() {
  // ✅ PREVENT MULTIPLE SIMULTANEOUS LOADS
  if (isUpsellLoading) {
    console.log('Upsell already loading, skipping...');
    return;
  }
  
  isUpsellLoading = true;
  
  try {
    const container = document.getElementById('cart-upsell-container');
    const upsellSection = document.querySelector('.cart-upsells');
    
    if (!container || !upsellSection) {
      console.log('Upsell elements not found');
      return;
    }

    // Hide section by default - will show only if we have relevant upsells
    upsellSection.style.display = 'none';
    container.innerHTML = '';
    
    // Remove existing carousel controls if any
    const existingControls = document.querySelector('.cart-upsells-controls');
    if (existingControls) {
      existingControls.remove();
    }

    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    
    console.log('Cart data:', cartData);
    
    // If cart is empty, hide upsells and clear recently added
    if (!cartData.items || cartData.items.length === 0) {
      console.log('Cart is empty, hiding upsells');
      recentlyAddedProducts.clear();
      return;
    }

    // Get cart product IDs to avoid showing products already in cart
    const cartProductIds = new Set(cartData.items.map(item => item.product_id));
    
    // Sync recently added products with current cart
    syncRecentlyAddedWithCart(cartData.items);
    
    console.log('Cart product IDs:', cartProductIds);
    console.log('Recently added products:', Array.from(recentlyAddedProducts));

    // Determine which categories are in cart
    const categoriesInCart = determineCategoriesInCart(cartData.items);
    
    console.log('Categories in cart:', categoriesInCart);
    
    // If no relevant category detected, hide upsells
    if (categoriesInCart.length === 0) {
      console.log('No relevant categories detected in cart, hiding upsells');
      return;
    }
    
    // Collect all available upsell products from ALL categories in cart
    let allAvailableProducts = [];
    
    // Fetch products from each relevant collection
    for (const category of categoriesInCart) {
      const upsellCollectionHandle = categoryUpsellMap[category];
      
      if (!upsellCollectionHandle) {
        console.log('No upsell collection mapped for category:', category);
        continue;
      }
      
      try {
        let collectionProducts;
        
        // Check cache first
        if (collectionCache.has(upsellCollectionHandle)) {
          console.log('Using cached products for:', upsellCollectionHandle);
          collectionProducts = collectionCache.get(upsellCollectionHandle);
        } else {
          // Fetch from API
          console.log('Fetching products for collection:', upsellCollectionHandle);
          const collectionResponse = await fetch(`/collections/${upsellCollectionHandle}/products.json`);
          
          if (!collectionResponse.ok) {
            console.error('Collection fetch failed:', collectionResponse.status);
            continue;
          }
          
          const collectionData = await collectionResponse.json();
          collectionProducts = collectionData.products || [];
          
          // Cache the results
          collectionCache.set(upsellCollectionHandle, collectionProducts);
          console.log('Cached products for:', upsellCollectionHandle);
        }
        
        console.log(`Products from ${category} collection:`, collectionProducts.length);
        
        // Filter products not in cart and available
        const filteredProducts = collectionProducts.filter(product => {
          const isInCart = cartProductIds.has(product.id);
          const isRecentlyAdded = recentlyAddedProducts.has(product.id);
          const isAvailable = product.variants && product.variants.length > 0 && product.variants[0].available;
          return !isInCart && !isRecentlyAdded && isAvailable;
        });
        
        console.log(`Available products from ${category}:`, filteredProducts.length);
        
        // Add to all available products
        allAvailableProducts.push(...filteredProducts.map(product => ({
          ...product,
          category: category,
          collectionName: upsellCollectionHandle
        })));
        
      } catch (error) {
        console.error(`Error fetching collection ${upsellCollectionHandle}:`, error);
      }
    }
    
    console.log('Total available products from all collections in cart:', allAvailableProducts.length);
    
    // If no available upsell products, hide the section
    if (allAvailableProducts.length === 0) {
      console.log('No available upsell products found from any collection in cart');
      return;
    }
    
    // Shuffle products and limit to maximum 8 for performance
    const shuffledProducts = [...allAvailableProducts]
      .sort(() => Math.random() - 0.5)
      .slice(0, 8);
    
    console.log('Available upsell products (shuffled):', shuffledProducts.length);
    
    // Reset carousel state
    currentSlide = 0;
    totalSlides = Math.ceil(shuffledProducts.length / slidesPerView);

    // Show the upsell section since we have relevant products
    upsellSection.style.display = 'block';
    
    // If only 2 or fewer products, show them without carousel (full width)
    if (shuffledProducts.length <= 2) {
      console.log('Showing 2 or fewer products without carousel');
      
      // Generate simple grid for 1-2 products
      const gridHTML = shuffledProducts.map(product => {
        let imageUrl = '';
        if (product.images && product.images.length > 0) {
          imageUrl = product.images[0].src;
        } else if (product.featured_image) {
          imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
        }
        
        if (imageUrl && !imageUrl.startsWith('http')) {
          imageUrl = `https:${imageUrl}`;
        }
        
        const productUrl = `/products/${product.handle}`;
        const price = product.variants && product.variants[0] ? parseFloat(product.variants[0].price).toFixed(2) : '0.00';
        const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
        const isInCart = cartProductIds.has(product.id);
        const isRecentlyAdded = recentlyAddedProducts.has(product.id);
        const isAdded = isInCart || isRecentlyAdded;
        
        return `
          <div class="upsell-product-grid" style="flex: 1; min-width: ${shuffledProducts.length === 1 ? '100%' : 'calc(25% - 10px)'}; margin: 0 5px;">
            <div class="upsell-product" data-category="${product.category}" data-product-id="${product.id}">
              <a href="${productUrl}" class="upsell-product__link" target="_blank">
                ${imageUrl ? `<img src="${imageUrl}&width=200&height=200&crop=center" alt="${product.title}" class="upsell-product__image" loading="lazy">` : '<div class="upsell-product__image" style="background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">No Image</div>'}
                <div class="upsell-product__title">${product.title}</div>
                <div class="upsell-product__price">$${price}</div>
              </a>
              ${variantId ? 
                `<button class="btn upsell-add-to-cart ${isAdded ? 'added' : ''}" 
                        data-variant-id="${variantId}" 
                        data-product-id="${product.id}"
                        ${isAdded ? 'disabled' : ''}>
                  ${isAdded ? 'Added ✓' : 'Add to Cart'}
                </button>`
               : ''}
            </div>
          </div>
        `;
      }).join('');
      
      container.innerHTML = `
        <div class="upsell-products-grid" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px;">
          ${gridHTML}
        </div>
      `;
      
    } else {
      // 3 or more products - show carousel with arrows
      console.log('Showing carousel for', shuffledProducts.length, 'products');
      
      // Create carousel wrapper
      const carouselWrapper = document.createElement('div');
      carouselWrapper.className = 'cart-upsells-carousel';
      carouselWrapper.style.position = 'relative';
      carouselWrapper.style.overflow = 'hidden';
      carouselWrapper.style.width = '100%';
      
      // Create slides container
      const slidesContainer = document.createElement('div');
      slidesContainer.className = 'cart-upsells-slides';
      slidesContainer.style.display = 'flex';
      slidesContainer.style.transition = 'transform 0.3s ease-in-out';
      slidesContainer.style.transform = 'translateX(0)';
      
      // Generate slides HTML
      shuffledProducts.forEach((product, index) => {
        let imageUrl = '';
        if (product.images && product.images.length > 0) {
          imageUrl = product.images[0].src;
        } else if (product.featured_image) {
          imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
        }
        
        if (imageUrl && !imageUrl.startsWith('http')) {
          imageUrl = `https:${imageUrl}`;
        }
        
        const productUrl = `/products/${product.handle}`;
        const price = product.variants && product.variants[0] ? parseFloat(product.variants[0].price).toFixed(2) : '0.00';
        const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
        const isInCart = cartProductIds.has(product.id);
        const isRecentlyAdded = recentlyAddedProducts.has(product.id);
        const isAdded = isInCart || isRecentlyAdded;
        
        const slide = document.createElement('div');
        slide.className = 'cart-upsell-slide';
        slide.style.flex = `0 0 calc(${100 / slidesPerView}% - 10px)`;
        slide.style.margin = '0 5px';
        slide.style.boxSizing = 'border-box';
        slide.style.minWidth = '0';
        
        slide.innerHTML = `
          <div class="upsell-product" data-category="${product.category}" data-product-id="${product.id}">
            <a href="${productUrl}" class="upsell-product__link" target="_blank">
              ${imageUrl ? `<img src="${imageUrl}&width=150&height=150&crop=center" alt="${product.title}" class="upsell-product__image" loading="lazy">` : '<div class="upsell-product__image" style="background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">No Image</div>'}
              <div class="upsell-product__title">${product.title}</div>
              <div class="upsell-product__price">$${price}</div>
            </a>
            ${variantId ? 
              `<button class="btn upsell-add-to-cart ${isAdded ? 'added' : ''}" 
                      data-variant-id="${variantId}" 
                      data-product-id="${product.id}"
                      ${isAdded ? 'disabled' : ''}>
                ${isAdded ? 'Added ✓' : 'Add to Cart'}
              </button>`
             : ''}
          </div>
        `;
        
        slidesContainer.appendChild(slide);
      });
      
      carouselWrapper.appendChild(slidesContainer);
      container.appendChild(carouselWrapper);
      
      // Add carousel controls below the carousel
      const controlsHTML = `
        <div class="cart-upsells-controls" style="display: flex; justify-content: center; gap: 10px; margin-top: 15px; position: relative; z-index: 10;">
          <button class="cart-upsells-prev" style="background: none; border: 1px solid #ddd; border-radius: 50%; width: 30px; height: 30px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; position: static;" aria-label="Previous">←</button>
          <button class="cart-upsells-next" style="background: none; border: 1px solid #ddd; border-radius: 50%; width: 30px; height: 30px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; position: static;" aria-label="Next">→</button>
        </div>
      `;
      
      container.insertAdjacentHTML('beforeend', controlsHTML);
      
      // Add event listeners for carousel controls
      const prevBtn = container.querySelector('.cart-upsells-prev');
      const nextBtn = container.querySelector('.cart-upsells-next');
      
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (currentSlide > 0) {
            currentSlide--;
            updateCarousel(slidesContainer);
            updateButtons(prevBtn, nextBtn);
          }
        });
        
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (currentSlide < totalSlides - 1) {
            currentSlide++;
            updateCarousel(slidesContainer);
            updateButtons(prevBtn, nextBtn);
          }
        });
        
        // Initialize button states
        updateButtons(prevBtn, nextBtn);
      }
    }
    
    // Add event listeners to Add to Cart buttons
    setTimeout(() => {
      container.querySelectorAll('.upsell-add-to-cart:not(.added)').forEach(button => {
        button.removeEventListener('click', handleAddToCart); // Remove any existing listeners
        button.addEventListener('click', handleAddToCart);
      });
      
      // Add target="_blank" to product links
      container.querySelectorAll('.upsell-product__link').forEach(link => {
        link.setAttribute('target', '_blank');
      });
    }, 100);
    
    console.log('Upsell products displayed from cart collections');

  } catch (error) {
    console.error('Error loading upsell products:', error);
  } finally {
    // ✅ RELEASE THE LOADING LOCK
    isUpsellLoading = false;
    console.log('Upsell loading complete, lock released');
  }
}

function updateCarousel(slidesContainer) {
  const slideWidth = 100 / slidesPerView;
  const translateX = -(currentSlide * 100);
  slidesContainer.style.transform = `translateX(${translateX}%)`;
}

function updateButtons(prevBtn, nextBtn) {
  if (!prevBtn || !nextBtn) return;
  
  if (currentSlide === 0) {
    prevBtn.style.opacity = '0.5';
    prevBtn.style.cursor = 'not-allowed';
    prevBtn.disabled = true;
  } else {
    prevBtn.style.opacity = '1';
    prevBtn.style.cursor = 'pointer';
    prevBtn.disabled = false;
  }
  
  if (currentSlide === totalSlides - 1) {
    nextBtn.style.opacity = '0.5';
    nextBtn.style.cursor = 'not-allowed';
    nextBtn.disabled = true;
  } else {
    nextBtn.style.opacity = '1';
    nextBtn.style.cursor = 'pointer';
    nextBtn.disabled = false;
  }
}

function determineCategoriesInCart(cartItems) {
  const categoryKeywords = {
    'n64': ['n64', 'nintendo 64', 'nintendo64', 'nintendo-64', '64'],
    'gameboy': ['gameboy', 'gb', 'game boy', 'game-boy'],
    'playstation': ['playstation', 'ps1', 'play station', 'play-station'],
    'snes': ['snes', 'super nintendo', 'super nintendo entertainment system'],
    'wii': ['wii', 'nintendo wii'],
    'ps-vita': ['ps vita', 'ps-vita', 'playstation vita', 'vita'],
    'ps2': ['ps2', 'playstation 2', 'playstation2'],
    'psp': ['psp', 'playstation portable'],
    'ps3': ['ps3', 'playstation 3', 'playstation3'],
    'gamecube': ['gamecube', 'game cube', 'game-cube', 'nintendo gamecube'],
    'ds-lite': ['ds lite', 'ds-lite', 'ds', 'nintendo ds'],
    '3ds': ['3ds', 'nintendo 3ds', '3ds console']
  };
  
  console.log('Analyzing cart items for categories:', cartItems);
  
  const foundCategories = new Set();
  
  cartItems.forEach(item => {
    const itemTitle = (item.title || '').toLowerCase();
    const itemProductType = (item.product_type || '').toLowerCase();
    const itemVendor = (item.vendor || '').toLowerCase();
    const itemHandle = (item.handle || '').toLowerCase();
    const itemTags = Array.isArray(item.tags) ? item.tags.map(tag => tag.toLowerCase()) : [];
    
    console.log(`Checking item: ${itemTitle}`, {itemTitle, itemProductType, itemVendor, itemHandle, itemTags});
    
    Object.keys(categoryKeywords).forEach(category => {
      const keywords = categoryKeywords[category];
      const hasKeyword = keywords.some(keyword => {
        const keywordRegex = new RegExp(`\\b${keyword}\\b`, 'i');
        
        return (
          keywordRegex.test(itemTitle) || 
          keywordRegex.test(itemProductType) ||
          keywordRegex.test(itemVendor) ||
          keywordRegex.test(itemHandle) ||
          itemTags.some(tag => keywordRegex.test(tag))
        );
      });
      
      if (hasKeyword) {
        foundCategories.add(category);
        console.log(`Found ${category} keyword in item: ${itemTitle}`);
      }
    });
  });
  
  console.log('Categories found in cart:', Array.from(foundCategories));
   
  return Array.from(foundCategories);
}

function handleAddToCart(e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  
  const variantId = this.getAttribute('data-variant-id');
  const productId = this.getAttribute('data-product-id');
  
  console.log('Add to cart clicked, variantId:', variantId, 'productId:', productId);
  
  // Disable button immediately
  this.disabled = true;
  this.style.opacity = '0.6';
  this.style.cursor = 'not-allowed';
  
  // Get product card
  const productCard = this.closest('.upsell-product');
  
  addUpsellProductToCart(variantId, productId, productCard, this);
}

async function addUpsellProductToCart(variantId, productId, productCard, button) {
  try {
    console.log('Adding product to cart, variantId:', variantId);
    
    // Show loading state
    if (button) {
      button.textContent = 'Adding...';
      button.style.background = '#ffa726';
      button.style.color = 'white';
    }
    
    // Mark product as recently added (temporary)
    recentlyAddedProducts.add(parseInt(productId));
    
    // Use Shopify's cart/add endpoint
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId),
          quantity: 1
        }]
      })
    });
    
    if (response.ok) {
      console.log('Product added successfully');
      const result = await response.json();
      
      // Update button to show "Added" permanently
      if (button) {
        button.textContent = 'Added ✓';
        button.style.background = '#4caf50';
        button.style.color = 'white';
        button.disabled = true;
        button.style.opacity = '0.8';
        button.style.cursor = 'default';
        button.classList.add('added');
      }
      
      // Add visual feedback to product card
      if (productCard) {
        productCard.style.position = 'relative';
        
        // Add checkmark overlay
        const checkmark = document.createElement('div');
        checkmark.innerHTML = '✓';
        checkmark.style.position = 'absolute';
        checkmark.style.top = '10px';
        checkmark.style.right = '10px';
        checkmark.style.background = '#4caf50';
        checkmark.style.color = 'white';
        checkmark.style.borderRadius = '50%';
        checkmark.style.width = '24px';
        checkmark.style.height = '24px';
        checkmark.style.display = 'flex';
        checkmark.style.alignItems = 'center';
        checkmark.style.justifyContent = 'center';
        checkmark.style.fontSize = '14px';
        checkmark.style.zIndex = '5';
        checkmark.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
        
        // Remove existing checkmark if any
        const existingCheckmark = productCard.querySelector('.upsell-checkmark');
        if (existingCheckmark) {
          existingCheckmark.remove();
        }
        checkmark.className = 'upsell-checkmark';
        productCard.appendChild(checkmark);
      }
      
      // Update cart subtotal
      updateCartSubtotal();
      
      // Update cart count without page reload
      updateCartCount();
      
      // Update Shopify cart drawer if it exists
      updateShopifyCartDrawer();
      
      // Clear cache to get fresh products
      collectionCache.clear();
      
      // 🔥 **CRITICAL FIX: Reload upsell products after adding**
      setTimeout(() => {
        loadUpsellProducts();
      }, 300);
      
      // Trigger cart update events with fromUpsell flag
      const cartUpdateEvent = new CustomEvent('cart:updated', {
        detail: { 
          cart: result,
          fromUpsell: true 
        }
      });
      document.dispatchEvent(cartUpdateEvent);
      
      console.log('Product added, upsells will reload');
      
    } else {
      console.error('Failed to add product to cart');
      
      // Remove from recently added since it failed
      recentlyAddedProducts.delete(parseInt(productId));
      
      // Show error message
      if (button) {
        button.textContent = 'Error!';
        button.style.background = '#f44336';
        button.style.color = 'white';
        
        setTimeout(() => {
          button.textContent = 'Add to Cart';
          button.style.background = '';
          button.style.color = '';
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.classList.remove('added');
        }, 2000);
      }
    }
  } catch (error) {
    console.error('Error adding product to cart:', error);
    
    // Remove from recently added since it failed
    recentlyAddedProducts.delete(parseInt(productId));
    
    // Show error message
    if (button) {
      button.textContent = 'Error!';
      button.style.background = '#f44336';
      button.style.color = 'white';
      
      setTimeout(() => {
        button.textContent = 'Add to Cart';
        button.style.background = '';
        button.style.color = '';
        button.disabled = false;
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.classList.remove('added');
      }, 2000);
    }
  }
}

function updateCartSubtotal() {
  // Get fresh cart data to update subtotal
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      console.log('Updating cart subtotal with:', cartData);
      
      // Find all subtotal elements
      const subtotalElements = document.querySelectorAll(
        '[data-subtotal], .ajaxcart__subtotal + div, .cart__subtotal, .cart-subtotal'
      );
      
      subtotalElements.forEach(element => {
        if (cartData.total_price) {
          const subtotal = (cartData.total_price / 100).toFixed(2);
          element.textContent = `$${subtotal}`;
          
          // Add animation
          element.style.transform = 'scale(1.1)';
          setTimeout(() => {
            element.style.transform = 'scale(1)';
          }, 300);
        }
      });
      
      // Also update any elements with specific selectors
      const specificSubtotal = document.querySelector('[data-subtotal]');
      if (specificSubtotal && cartData.total_price) {
        const subtotal = (cartData.total_price / 100).toFixed(2);
        specificSubtotal.textContent = `$${subtotal}`;
      }
    })
    .catch(error => {
      console.error('Error updating subtotal:', error);
    });
}

function updateCartCount() {
  // Find all cart count elements and update them
  const cartCountElements = document.querySelectorAll(
    '.cart-count, [data-cart-count], .header__cart-count, .cart-count-bubble, .js-cart-count'
  );
  
  cartCountElements.forEach(element => {
    const currentCount = parseInt(element.textContent) || 0;
    element.textContent = currentCount + 1;
    
    if (element.hasAttribute('data-cart-count')) {
      element.setAttribute('data-cart-count', currentCount + 1);
    }
    
    // Add animation
    element.style.transform = 'scale(1.2)';
    setTimeout(() => {
      element.style.transform = 'scale(1)';
    }, 300);
  });
}

async function updateShopifyCartDrawer() {
  try {
    console.log('Updating Shopify cart drawer and subtotal');
    
    // Get fresh cart data
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    
    // Update subtotal
    updateCartSubtotal();
    
    // Trigger Shopify's cart update events
    const cartUpdateEvent = new CustomEvent('cart:updated', {
      detail: { 
        cart: cartData,
        fromUpsell: true 
      }
    });
    document.dispatchEvent(cartUpdateEvent);
    
    // Also trigger AJAX cart events
    document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { 
      detail: cartData 
    }));
    
    // ✅ KEEP THESE EVENTS - they update the cart drawer
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:build'));
    
    // Force refresh cart contents if drawer is open
    const cartDrawerContents = document.querySelector('.cart-drawer__contents, .drawer__inner, .cart__contents');
    if (cartDrawerContents) {
      // Re-fetch cart HTML
      fetch('/cart?view=ajax')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartContents = doc.querySelector('.cart-drawer__contents, .drawer__inner, .cart__contents');
          if (newCartContents) {
            cartDrawerContents.innerHTML = newCartContents.innerHTML;
            
            // Update subtotal in the refreshed content
            setTimeout(() => {
              updateCartSubtotal();
            }, 100);
          }
        })
        .catch(err => console.error('Error refreshing cart drawer:', err));
    }
    
  } catch (error) {
    console.error('Error updating Shopify cart drawer:', error);
  }
}